<template>
   <div class='search'>
    <WebVue></WebVue>
   </div>
</template>

<script>
import userapi from "@/api/user";
import axios from "axios";
import WebVue from './web.vue'
export default {
  components:{
    WebVue
  },
    props: {},
    data() {
        return {
            isPhone: false,
            lzli: [],
            searchText: "",
            reList: [],
            imageUrl: ""
        };
    },
    methods: {
        getImgBase64(file, callback) {
            var url = "";
            //创建文件阅读器
            var reader = new FileReader();
            //创建图片
            var img = new Image();
            //读取为数据url
            reader.readAsDataURL(file);
            reader.onload = (e) => {
                img.src = e.target.result;
                img.onload = () => {
                    var canvas = document.createElement("canvas");
                    var context = canvas.getContext("2d");
                    //核心Js就这个图片绘制成canvas
                    context.drawImage(img, 0, 0);
                    //canvas绘制的图片转换成base64格式信息
                    url = canvas.toDataURL();
                    callback(url);
                };
            };
        },
        beforeAvatarUpload(file) {
            // const loading = this.$loading( {
            //     lock: true,
            //     text: "Loading",
            //     spinner: "el-icon-loading",
            //     background: "rgba(0, 0, 0, 0.7)",
            // } );
            let binaryData = [];
            binaryData.push(file);
            this.imageUrl = window.URL.createObjectURL(new Blob(binaryData));
            // this.getImgBase64( file, ( url ) => {
            //     axios
            //         .post(
            //             "http://122.152.198.146:9987/questionanswer3",
            //             {
            //                 image: url.replace( "data:image/png;base64,", "" ),
            //             },
            //             {
            //                 headers: {
            //                     "Content-Type": "application/json",
            //                     Charset: "UTF-8",
            //                 },
            //             }
            //         )
            //         .then( ( res ) => {
            //             loading.close();
            //             console.log( res.data.data )
            //             // console.log(res, JSON.stringify(res.data.data));
            //             // this.reList=[]
            //             for ( var a = 0; a < this.reList.length; a++ ) {
            //                 this.reList[ a ].show = false
            //             }
            //             this.reList = [ {
            //                 path: res.data.data.imgpath,
            //                 name: res.data.data.name,
            //                 description: res.data.data.description,
            //                 area: res.data.data.area,
            //                 nameother: res.data.data.nameother,
            //                 show: true
            //             } ]
            //         } );
            // } );
        },
        handle_success(res) {
            if (res.status == 0) {
                this.reList = []
                for (var a = 0; a < this.reList.length; a++) {
                    this.reList[a].show = false
                }
                this.reList = [{
                    path: res.data.imgpath,
                    name: res.data.name,
                    description: res.data.description,
                    area: res.data.area,
                    nameother: res.data.nameother,
                    show: true
                }]
            }
            else {
                alert(res.data)
            }
        },
        goSearch(item) {
            this.searchText = item;
            this.gogogo();
        },
        gogogo() {
            if (this.searchText == "") {
                alert("请输入内容");
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            userapi
                .getRequest("/search/questionanswer2", {
                    keyword: this.searchText,
                })
                .then((res) => {
                    loading.close();
                    for (var a = 0; a < this.reList.length; a++) {
                        this.reList[a].show = false
                    }
                    for (var a = 0; a < res.data.data.length; a++) {
                        res.data.data[a].show = true
                    }
                    this.reList.push(...res.data.data);
                }).catch(error => {
                    loading.close();
                    this.$message.error("请确认需要检索内容");
                    console.log(
                        "error", error
                    );
                })
        },
        refresh(){
          let dom=document.getElementById("refresh");
          dom.classList.add('rotage')
          setTimeout(()=> {
            dom.classList.remove('rotage');
        }, 500); 
        }
    },
    created() { },
    mounted() {
        // if (window.innerWidth > 1100) {
        //     this.isPhone = false
        // } else {
        //     this.isPhone = true
        // }
        // userapi
        //     .getRequest("/api/getRackSerach", {
        //         type: 2,
        //         count: 4
        //     })
        //     .then((res) => {
        //         var re = []
        //         for (var a = 0; a < res.data.length; a++) {
        //             re.push(res.data[a].c_info)
        //         }
        //         this.lzli = re;
        //     });
    },
};
</script>
<style scoped>
/* @import url('./search.css'); */
.search{}
</style>


// WEBPACK FOOTER //
// src/views/Search/search.vue